import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiSmartphone, FiFileText } from "react-icons/fi";
import Header from "../../components/Header";
import Button from "../../components/Button";
import InputField from "../../components/InputField";
import "./style.scss";
import logo1 from "../../assets/imgs/logo.png";
import logo2 from "../../assets/imgs/logo2.png";
import axios from "axios";

const Home = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [orderCode, setOrderCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePhone = (number) => {
    return /^1[3-9]\d{9}$/.test(number);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!orderCode) {
      setError("请输入订单编号");
      return;
    }

    if (!phone) {
      setError("请输入手机号码");
      return;
    }

    if (!validatePhone(phone)) {
      setError("请输入正确的手机号码");
      return;
    }

    setIsLoading(true);
    // setError("");

    try {
      const response = await axios.get(
        // `http://localhost:8080/admin-api/crm/frwj-order/getDetailByPhone`,
        // `http://47.111.143.121:8080/admin-api/crm/frwj-order/getDetailByPhone`,
        `https://www.furenwanjia.com/admin-api/crm/frwj-order/getDetailByPhone`,
        {
          params: {
            orderCode,
            phone,
          },
        }
      );

      if (response.data.code == 0) {
        console.log("response", response);
        const deptResponse = await axios.get(
          // `http://localhost:8080/admin-api/crm/frwj-order/getDeptDetail`,
          // `http://47.111.143.121:8080/admin-api/crm/frwj-order/getDetailByPhone`,
          `https://www.furenwanjia.com/admin-api/crm/frwj-order/getDeptDetail`,
          {
            params: {
              id: response.data.data.storeId,
            },
          }
        );

        navigate(`/detail/`, {
          state: {
            orderDetail: response.data.data,
            deptDetail: deptResponse.data.data,
          },
        });
      } else {
        setError("未查询到订单信息");
      }
    } catch (err) {
      console.error("API请求失败:", err);
      setError("查询失败，请稍后重试");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="query-page">
      <Header title="福人万家" />
      <div className="form-container">
        <div className="illustration">
          <div className="logo-container">
            <img src={logo1} alt="福人万家logo" className="logo1" />
            <img src={logo2} alt="福人万家logo" className="logo2" />
          </div>
          <h2>一心一意 美好到家</h2>
          <p>福人万家订单查询系统欢迎您</p>
        </div>

        <form onSubmit={handleSubmit} className="query-form">
          {error && <div className="error-message">{error}</div>}

          <InputField
            icon={<FiFileText />}
            label="订单编号"
            placeholder="请输入订单编号"
            value={orderCode}
            onChange={(e) => setOrderCode(e.target.value)}
          />

          <InputField
            icon={<FiSmartphone />}
            label="手机号码"
            type="tel"
            placeholder="请输入手机号码"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            maxLength={11}
          />

          <Button
            type="submit"
            loading={isLoading}
            disabled={isLoading}
            className="center"
          >
            {isLoading ? "查询中..." : "查询"}
          </Button>
        </form>
      </div>

      {/* <div className="footer-note">
        <p>安全提示：我们将严格保护您的个人信息</p>
      </div> */}
      <footer className="beian-footer">
        <div className="beian-content">
          {/* <span>© 2025 福人万家 版权所有</span> */}
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
          >
            闽ICP备2025109161号-1
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
